// Centralized API URL configuration
// Uses VITE_API_URL env var, falls back to relative /api for Traefik
export const API_BASE_URL = import.meta.env.VITE_API_URL ?? '/api';
